<mat-sidenav-container id="imgoing-container" class="full-height" [class.default-color]="isIE"
    [class.mobile-view]="isMobile">

    <mat-sidenav #sideBar mode="over" [opened]="isSideBarOpened">
        <ig-side-bar *ngIf="isMobile||isSmallestPC" (onClose)="sideBar.close()"></ig-side-bar>
    </mat-sidenav>
    <mat-sidenav-content class="full-height" *ngIf="isSettingsLoaded">
        <div class="page-header" *ngIf="isNeedSideBar">
            <ig-button mat-icon-button (trigger)="sideBar.open()">
                <mat-icon>menu</mat-icon>
            </ig-button>
            <h1>{{mobileMenuTitle}}</h1>
        </div>
        <div class="ig-container-fluid full-height" [class.hide-topbar]="isHideTopBar">
            <ig-row class="stick-top-bar"
                *ngIf="!allFrontendSettings.customSettings.menuStyle.isSideBar&&isNeedSideBar">
                <ig-col [xs]="12">
                    <ig-top-bar></ig-top-bar>
                </ig-col>
            </ig-row>
            <ig-row class="full-height component-wrap">
                <ig-col class="stick-side-bar" [xs]="3"
                    *ngIf="isNeedSideBar&&allFrontendSettings.customSettings.menuStyle.isSideBar">
                    <ig-side-bar></ig-side-bar>
                </ig-col>
                <ig-col class="no-margin no-overflow-x"
                    [xs]="isNeedSideBar&&allFrontendSettings.customSettings.menuStyle.isSideBar&&!isMobile ? 9 : 12">
                    <div wholewrap
                        [class.top-bar-mode]="isNeedSideBar&&!allFrontendSettings.customSettings.menuStyle.isSideBar">
                        <router-outlet #outlet="outlet"></router-outlet>
                    </div>
                </ig-col>
            </ig-row>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>

<ig-page-spinner #spinner></ig-page-spinner>

<!-- NormanOK uses in-app browser, which shows this browser check and cannot hide -->
<div *ngIf="isIE&&isShowUpgradeBrowser&&hubName!=='NormanOK'" class="browser-upgrade-wrap">
    Your web browser is out of date. Update to a modern browser (Chome or Firefox) for more security, speed and the best
    experience on this site.
    <span upgrade class="btn-div" (click)="upgradeBrowser()">Upgrade</span>
    <span ignore class="btn-div" (click)="hideUpgradeBrowser()">ignore</span>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/visitor.component.html